
import React from 'react'
import { Routes, Route, useLocation } from "react-router-dom"; 
import Header from './Components/Header/Header'
import Home from './Components/Home/Home';
import Product from './Components/Product/Product';
import Pricing from './Components/Pricing/Pricing';
import Help from './Components/Help/Help';
import Talk from './Components/Talk/Talk';
import CogniCampuX from './Components/Product/CogniCampuX';
import Footer from './Components/Footer/Footer';
import Hms from './Components/Product/Hms';
import PrivacyPolicy from './Components/Policy/PrivacyPolicy';
import Refundpolicy from './Components/Policy/Refundpolicy';
import SignUp from './Components/SingUp/SignUp';
import Login from './Components/Login/Login';
import Error from './Components/Error/Error';

const App = () => {

  const Location = useLocation();
  return (
    <div>
   
    
 
      <Routes>
          <Route index element={<Home />} />
          <Route path="Product" element={<Product />} />
          <Route path="Pricing" element={<Pricing />} />
          <Route path="CogniCampuX" element={<CogniCampuX/>} />
          <Route path="Hms" element={<Hms/>} />
          <Route path="Help" element={<Help />} />
          <Route path="Talk" element={<Talk />} />
          <Route path="Footer" element={<Footer/>} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicy/>} />
          <Route path="Refundpolicy" element={<Refundpolicy/>}/>
          <Route path="SignUp" element={<SignUp/>}/>
          <Route path="Login" element={<Login/>}/>
          <Route path="Error" element={<Error/>}/>  
      </Routes> 
      
    </div>
  )
}

export default App
